module.exports = __webpack_public_path__ + "node_modules/icheck/skins/polaris/polaris.png?01417e20";